import React, { useContext } from 'react';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import trans from 'translate';
import { TabsContext } from '../NewOrder';
import { Button, Fields } from '../../../../../../../Common';
import { OrdersContext } from '../../../../../../../Modals/EditTokensModal/EditOrderDetails';
import './FieldsWrapper.scss';
import { createValidation } from '../../../../../../../../utils/validation';
import { displayFloats } from '../../../../../../../../utils/numbersDisplay';
import WalletValidator from '../../../../../../../hoc/WalletValidator/WalletValidator';
import { getValueByMultiProps } from '../../../../../../../../utils/mapper';

const yesterday = new Date(Date.now() - 86400000);

export const defaultValidationSchema = {
  amount_source: yup.number().required(' ').typeError(' '),
  price_usd: yup.number().required(' ').typeError(' '),
  valid_until: yup.date().min(yesterday, 'valid untils should not be before today date').typeError(' ').required(' '),
};
/* eslint-disable */
export const sharedFields = [
  {
    name: 'price_usd',
    id: 'Price per token',
    className: 'w-50 fill-at-mobile',
    label: 'common.price_usd',
    tag: 'number',
    placeholder: 0,
    inlineHint: <span>$</span>,
    // hint: ({ values }) => (
    //   <>
    //     {!!(values.amount_source * values?.price_usd) && (
    //       <span>${displayFloats(values?.price_usd * values.amount_source, 3)}</span>
    //     )}
    //   </>
    // ),
    infoHint: 'Select the price in USD for each token that will trigger this transaction',
  },
  {
    name: 'slippage',
    id: 'Slippage',
    className: 'w-50 fill-at-mobile',
    label: 'common.slippage',
    // value: '2.5%',
    renderValue: (value) => `${value}%`,
    disabled: true,
    type: 'string',
    infoHint: 'Current slippage is not guaranteed for highly volatile transactions',
    // help: () => (
    //   <>
    //     <span>{trans('hpool.slippage_warning')}</span>
    //   </>
    // ),
  },
  {
    name: 'valid_until',
    id: 'Valid until',
    className: 'w-50 fill-at-mobile',
    label: 'common.valid_until',
    type: 'date',
    infoHint: 'Last date trade order will be executed',
  },
];

const getTokenSymbol = (token) => getValueByMultiProps(token, ['token_symbol', 'symbol']);

export const defaultFields = ({ selectedToken, label, infoHint = '' } = {}) => [
  {
    name: 'amount_source',
    id: 'Amount',
    className: 'w-50 fill-at-mobile',
    label,
    tag: 'number',
    placeholder: 0,
    inlineHint: <span>{getTokenSymbol(selectedToken)}</span>,
    infoHint,
  },
  ...sharedFields,
];

export default function FieldsWrapper({
  inlineHint,
  fields: passedFields,
  passedOnSubmit,
  submitText,
  type,
  validationSchema,
  ...rest
}) {
  const { onSubmit, loading, hordUsdPrice } = useContext(TabsContext);
  const { onPrev, selectedToken } = useContext(OrdersContext);

  const fieldsState = {
    selectedToken,
  };

  const mergedSchema = createValidation({ ...defaultValidationSchema, ...validationSchema });
  const statFullFields = !passedFields ? defaultFields(fieldsState) : passedFields(fieldsState);

  const handleSubmit = (values) => (passedOnSubmit ? passedOnSubmit(values, type) : onSubmit(values, type));

  return (
    <Fields fields={statFullFields} validationSchema={mergedSchema} onSubmit={handleSubmit} {...rest}>
      {({ disabled, errors, defaultWrapperClass }) => (
        <div className={defaultWrapperClass}>
          <Button className="button back" onClick={onPrev} text="common.cancel" />
          <WalletValidator>
            <Button
              type="submit"
              className="button green"
              text={submitText}
              loadingText="loading.creating"
              loading={loading}
              disabled={disabled || loading}
              requireWallet
            />
          </WalletValidator>
        </div>
      )}
    </Fields>
  );
}

FieldsWrapper.defaultProps = {
  validationSchema: {},
  fields: defaultFields,
  passedOnSubmit: null,
  inlineHint: 'HORD',
};

FieldsWrapper.propTypes = {
  fields: PropTypes.func,
  submitText: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  validationSchema: PropTypes.object,
  passedOnSubmit: PropTypes.object,
  inlineHint: PropTypes.string,
};
